import { useFormContext } from 'react-hook-form'

import { ControlledNumberInput } from '@fortem-monorepo/react-ui'
import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

export interface SettlementCycleFieldProps {}

export const SettlementCycleField: React.FC<SettlementCycleFieldProps> = ({}) => {
  const { control, register } = useFormContext<{ settlement_cycle: number }>()
  return (
    <FormField
      name="settlement_cycle"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Settlement Cycle</FormLabel>
              <FormError />
            </div>
            <ControlledNumberInput
              {...register('settlement_cycle')}
              placeholder={'Enter the settlement cycles...'}
            />
          </FormItem>
        )
      }}
    />
  )
}
